module.exports = __webpack_public_path__ + "img/product-banner2.5aefbcf9.png";